var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h3',[_vm._v("temporarily down for maintenance . . .")]),_c('p',[_vm._v("please come back in a while ...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }